class FontServiceFontFace {
  load = (manifest) => {
    for (let item of manifest) {
      let font = new FontFace(item.name, `url(${item.url})`, item.options)
      document.fonts.add(font)
    }
    return document.fonts.ready
  }
}

let service = new FontServiceFontFace()
export default service
